export default __webpack_public_path__ + "static/media/reward-tiers5.ce6642d4.webp";